import { render, staticRenderFns } from "./CreatePasswordForm.vue?vue&type=template&id=06c1d8d8&scoped=true&"
import script from "./CreatePasswordForm.vue?vue&type=script&lang=js&"
export * from "./CreatePasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./CreatePasswordForm.vue?vue&type=style&index=0&id=06c1d8d8&prod&lang=sass&scoped=true&"
import style1 from "./CreatePasswordForm.vue?vue&type=style&index=1&id=06c1d8d8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1d8d8",
  null
  
)

export default component.exports